// antd 5 eliminó Less: el reset sustituye a antd/lib/style/index.less y los
// temas claro/oscuro pasan a ser design tokens en src/theme/antdTheme.js,
// aplicados por ConfigProvider desde localization.jsx.
import 'antd/dist/reset.css'
import './global.scss' // app & third-party component styles

import React from 'react'
import { createRoot } from 'react-dom/client'
// import { createHashHistory } from 'history'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
// import { logger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'

import {
  MsalProvider,
  UnauthenticatedTemplate,
  MsalAuthenticationTemplate,
} from '@azure/msal-react'
import { InteractionType } from '@azure/msal-browser/dist'
import { PublicClientApplication, EventType } from '@azure/msal-browser'

// import { loadUser, OidcProvider } from 'redux-oidc'
import { ConfigProvider } from 'antd'
import locale from 'antd/lib/locale/es_ES'
import reducers from '@redux/reducers'
import sagas from '@redux/sagas'
import Localization from './localization'
import Router from './router'
import * as serviceWorker from './serviceWorker'

import { msalConfig } from './authConfig'
import Login from './login'
import { esRutaSinAutenticacion } from './services/rutasSinAutenticacion'

// import userManager from './userManager'
import history from './history'

const container = document.getElementById('root')
const root = createRoot(container)

// middlewared
// const history = createHashHistory()

const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]
// if (import.meta.env.NODE_ENV === 'development') {
//   middlewares.push(logger)
// }

/* eslint-disable no-underscore-dangle */
const composeFunctions = [applyMiddleware(...middlewares)]
if (import.meta.env.NODE_ENV === 'development') {
  composeFunctions.push(
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  )
}
const store = createStore(reducers(history), compose(...composeFunctions))
// loadUser(store, userManager)

const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.enableAccountStorageEvents()

// Account selection logic is app dependent. Adjust as needed for different use cases.
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

msalInstance.addEventCallback(async event => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const { account } = event.payload
    msalInstance.setActiveAccount(account)
  }
})

sagaMiddleware.run(sagas)
/* eslint-enable */

// const logining = inProgress === "login";
// const logedIn = accounts.length > 0;
// const mustLogin = !logedIn && !logining;

// try {
//   // chek if is legged in
//   const accounts = msalInstance.getAllAccounts();
//   if (accounts.length > 0) {
//     store.dispatch({ type: 'LOGIN_SUCCESS', payload: accounts[0] });
//     console.log('logged in');
//   }else{
//     store.dispatch({ type: 'LOGIN_REQUEST' });
//     console.log('not logged in');
//     msalInstance.loginRedirect(loginRequest);
//   }
// } catch (err) {
//   // handle error
// }

// Se decide una sola vez, al arrancar, con la url con la que se ha abierto la pestaña: el generador
// de diseños navega directamente a la página de impresión, nunca llega a ella desde dentro del admin.
const sinAutenticacion = esRutaSinAutenticacion(window.location.pathname)

root.render(
  <>
    <Provider store={store}>
      <Localization>
        <MsalProvider instance={msalInstance}>
          {sinAutenticacion ? (
            // Sin MsalAuthenticationTemplate no hay redirección a B2C. El MsalProvider se mantiene
            // porque los componentes y las peticiones siguen preguntándole si hay cuenta activa.
            <ConfigProvider locale={locale}>
              <Router history={history} />
            </ConfigProvider>
          ) : (
            <>
              <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <ConfigProvider locale={locale}>
                  <Router history={history} />
                </ConfigProvider>
              </MsalAuthenticationTemplate>
              <UnauthenticatedTemplate>
                <Login />
              </UnauthenticatedTemplate>
            </>
          )}
        </MsalProvider>
      </Localization>
    </Provider>
  </>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history, msalInstance }
